export default "__VITE_ASSET__555ad44b__"